import { QueryClientProvider } from '@tanstack/react-query';
import { queryClientGlobal } from './query-client';
import type { ReactNode } from 'react';

export const QueryClientProviderGlobal = ({ children }: { children: ReactNode }) => {
  return <QueryClientProvider client={queryClientGlobal}>{children}</QueryClientProvider>;
};
